/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 * One endpoint's limit for a company: what applies, where it came from, and what they are actually using. \[isOverride\] is what lets the screen show "500 (default)" differently from "500 (set by ops)" --- without it an operator cannot tell whether clearing the row would change anything.
 * @export
 * @interface CompanyApiRateLimitRow
 */
export interface CompanyApiRateLimitRow {
  /**
   *
   * @type {string}
   * @memberof CompanyApiRateLimitRow
   */
  endpoint: string;
  /**
   *
   * @type {number}
   * @memberof CompanyApiRateLimitRow
   */
  requestsPerHour: number;
  /**
   *
   * @type {boolean}
   * @memberof CompanyApiRateLimitRow
   */
  isOverride: boolean;
  /**
   *
   * @type {number}
   * @memberof CompanyApiRateLimitRow
   */
  defaultRequestsPerHour: number;
  /**
   *
   * @type {number}
   * @memberof CompanyApiRateLimitRow
   */
  usedInLastHour: number;
  /**
   *
   * @type {string}
   * @memberof CompanyApiRateLimitRow
   */
  updatedByEmail?: string | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CompanyApiRateLimitRow
   */
  updatedAt?: OffsetDateTime | null;
}

/**
 * Check if a given object implements the CompanyApiRateLimitRow interface.
 */
export function instanceOfCompanyApiRateLimitRow(
  value: object,
): value is CompanyApiRateLimitRow {
  if (!("endpoint" in value) || value["endpoint"] === undefined) return false;
  if (!("requestsPerHour" in value) || value["requestsPerHour"] === undefined)
    return false;
  if (!("isOverride" in value) || value["isOverride"] === undefined)
    return false;
  if (
    !("defaultRequestsPerHour" in value) ||
    value["defaultRequestsPerHour"] === undefined
  )
    return false;
  if (!("usedInLastHour" in value) || value["usedInLastHour"] === undefined)
    return false;
  return true;
}

export function CompanyApiRateLimitRowFromJSON(
  json: any,
): CompanyApiRateLimitRow {
  return CompanyApiRateLimitRowFromJSONTyped(json, false);
}

export function CompanyApiRateLimitRowFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CompanyApiRateLimitRow {
  if (json == null) {
    return json;
  }
  return {
    endpoint: json["endpoint"],
    requestsPerHour: json["requestsPerHour"],
    isOverride: json["isOverride"],
    defaultRequestsPerHour: json["defaultRequestsPerHour"],
    usedInLastHour: json["usedInLastHour"],
    updatedByEmail:
      json["updatedByEmail"] == null ? undefined : json["updatedByEmail"],
    updatedAt: json["updatedAt"] == null ? undefined : json["updatedAt"],
  };
}

export function CompanyApiRateLimitRowToJSON(
  json: any,
): CompanyApiRateLimitRow {
  return CompanyApiRateLimitRowToJSONTyped(json, false);
}

export function CompanyApiRateLimitRowToJSONTyped(
  value?: CompanyApiRateLimitRow | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    endpoint: value["endpoint"],
    requestsPerHour: value["requestsPerHour"],
    isOverride: value["isOverride"],
    defaultRequestsPerHour: value["defaultRequestsPerHour"],
    usedInLastHour: value["usedInLastHour"],
    updatedByEmail: value["updatedByEmail"],
    updatedAt: value["updatedAt"],
  };
}
